import axios from 'axios';
import { API_URLS } from '../config';
import { UserInfo } from '../../types';

interface SimplifyResponse {
  simplified_text: string;
}

export const simplifyText = async (
  text: string,
  language: string,
  level: number,
  userInfo: UserInfo,
  sessionId: string
): Promise<string> => {
  try {
    const response = await axios.post<SimplifyResponse>(
      API_URLS.simplify,
      {
        text,
        language,
        level,
        user_info: {
          languageLevel: userInfo.languageLevel,
          age: userInfo.age,
          nativeLanguage: userInfo.nativeLanguage,
          conversationType: userInfo.conversationType
        },
        session_id: sessionId
      },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data.simplified_text;
  } catch (error) {
    console.error('Error simplifying text:', error);
    throw error;
  }
};
